var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "aria-current": "location",
      "active": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.displayText("partner.partner_area", "合作夥伴專區")) + " ")]), _vm.fromPartnerPage ? _c('b-breadcrumb-item', {
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v(" " + _vm._s(_vm.displayText("partner.partner_management", "合作夥伴管理")) + " ")]) : _vm._e(), !_vm.isVerifyPage ? _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.displayText("partner.partner_worker_management", "夥伴員工管理")))]) : _vm._e(), _vm.isVerifyPage ? _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.displayText("partner.partner_worker_verify_page", "夥伴員工審核")))]) : _vm._e()], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "\n        d-flex\n        flex-column flex-xl-row\n        align-items-start align-items-xl-center\n        justify-content-between\n        mb-4 mb-xl-2\n      "
  }, [!_vm.isVerifyPage ? _c('h4', {
    staticClass: "col-12 col-xl-2 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.displayText("partner.partner_worker_management", "夥伴員工管理")) + " ")]) : _vm._e(), _vm.isVerifyPage ? _c('h4', {
    staticClass: "col-12 col-xl-2 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.displayText("partner.partner_worker_verify_page", "夥伴員工審核")) + " ")]) : _vm._e(), _c('div', {
    staticClass: "\n          col-12 col-xl-8\n          d-flex\n          flex-column flex-xl-row\n          align-items-start align-items-xl-center\n        "
  }, [_vm.checkPermission([_vm.consts.PARTNER_WORKER_MODIFY]) && _vm.hasSelectedWorker ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.showPartnerWorkerChangePartner = true;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.displayText("partner.partner_worker_batch_update_partner", "批次更新夥伴公司")) + " ")]) : _vm._e(), _vm.checkPermission([_vm.consts.PARTNER_WORKER_MODIFY]) && _vm.hasSelectedWorker ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.showPartnerWorkerChangeStaff = true;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.displayText("partner.partner_worker_batch_update_staff", "批次更新業務")) + " ")]) : _vm._e(), _vm.checkPermission([_vm.consts.PARTNER_WORKER_VERIFY]) && _vm.isVerifyPage ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.approved
    }
  }, [_vm._v(" " + _vm._s(_vm.displayText("partner.partner_worker_verify_approved", "審核成功")) + " ")]) : _vm._e(), _vm.checkPermission([_vm.consts.PARTNER_WORKER_VERIFY]) && _vm.isVerifyPage ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.rejected
    }
  }, [_vm._v(" " + _vm._s(_vm.displayText("partner.partner_worker_verify_rejected", "審核失敗")) + " ")]) : _vm._e(), _vm.checkPermissionAny([_vm.consts.PARTNER_WORKER_LIST_VIEW, _vm.consts.PARTNER_WORKER_VERIFY_LIST_VIEW]) ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.exportPartnerWorker();
      }
    }
  }, [_vm._v(_vm._s(_vm.displayText('partner.export_partner_worker', '匯出夥伴員工')) + " ")]) : _vm._e(), _vm.checkPermission([_vm.consts.PARTNER_WORKER_CREATE]) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-upload",
      modifiers: {
        "modal-upload": true
      }
    }],
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(_vm._s(_vm.displayText("partner.partner_worker_import", "批次匯入夥伴員工")))]) : _vm._e(), _vm.checkPermission([_vm.consts.PARTNER_WORKER_CREATE]) && !_vm.isVerifyPage ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary",
      "to": _vm.partnerWorkerCreateRoute
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(_vm._s(_vm.displayText("partner.partner_worker_add", "新增夥伴員工")))]) : _vm._e(), _c('b-input-group', {
    staticClass: "ml-0"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": _vm.displayText('partner.worker_search_placeholder', '請輸入姓名、手機號碼、email、員工編號')
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getPartnerWorkers();
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": function click($event) {
        return _vm.getPartnerWorkers();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1), _c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-1-inner",
      modifiers: {
        "collapse-1-inner": true
      }
    }],
    staticClass: "flex-shrink-0 ml-0 ml-xl-1",
    attrs: {
      "variant": "link"
    }
  }, [_vm._v(" " + _vm._s(_vm.displayText("partner.worker_search_advanced", "進階搜尋"))), _c('i', {
    staticClass: "fa fa-chevron-down"
  })])], 1)]), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse-1-inner"
    }
  }, [_c('div', {
    staticClass: "border p-2"
  }, [_c('b-form', [_c('div', {
    staticClass: "d-flex flex-column flex-xl-row"
  }, [_vm.hiddenSearchField('worker_name') ? _c('b-form-group', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": _vm.displayText('partner.worker_name', '員工姓名'),
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-lg": "9"
    }
  }, [_c('b-form-input', {
    staticClass: "mr-2",
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearch();
      }
    },
    model: {
      value: _vm.query.name,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "name", $$v);
      },
      expression: "query.name"
    }
  })], 1) : _vm._e(), _vm.hiddenSearchField('partner_name') ? _c('b-form-group', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": _vm.displayText('partner.title', '合作夥伴'),
      "label-cols-sm": "3",
      "label-cols-lg": "2"
    }
  }, [_c('AppSingleSelect', {
    attrs: {
      "options": _vm.partners
    },
    on: {
      "input": _vm.handleSearch
    },
    model: {
      value: _vm.query.partner,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "partner", $$v);
      },
      expression: "query.partner"
    }
  })], 1) : _vm._e()], 1), _c('div', {
    staticClass: "d-flex flex-column flex-xl-row"
  }, [_vm.hiddenSearchField('staff_name') ? _c('b-form-group', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": _vm.displayText('partner.worker_sales', '業務員'),
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-lg": "9"
    }
  }, [_c('AppSingleSelect', {
    attrs: {
      "options": _vm.staffs
    },
    on: {
      "input": _vm.handleSearch
    },
    model: {
      value: _vm.query.staff,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "staff", $$v);
      },
      expression: "query.staff"
    }
  })], 1) : _vm._e(), _vm.hiddenSearchField('job_specialty') ? _c('b-form-group', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": _vm.displayText('partner.worker_job_specialty_name', '服務科室'),
      "label-cols-sm": "3",
      "label-cols-lg": "2"
    }
  }, [_c('AppSingleSelect', {
    attrs: {
      "options": _vm.jobSpecialties
    },
    on: {
      "input": _vm.handleSearch
    },
    model: {
      value: _vm.query.job_specialties,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "job_specialties", $$v);
      },
      expression: "query.job_specialties"
    }
  })], 1) : _vm._e()], 1), _c('div', {
    staticClass: "d-flex flex-column flex-xl-row"
  }, [_vm.hiddenSearchField('status') ? _c('b-form-group', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": _vm.displayText('partner.worker_verify_status', '審核狀態'),
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-lg": "9"
    }
  }, [_c('b-form-select', {
    staticClass: "mr-2 form-control form-control-sm",
    attrs: {
      "options": _vm.statusOptions
    },
    model: {
      value: _vm.query.status,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "status", $$v);
      },
      expression: "query.status"
    }
  })], 1) : _vm._e(), _vm.hiddenSearchField('dept_name') ? _c('b-form-group', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": _vm.displayText('partner.worker_dept_name', '部門名稱'),
      "label-cols-sm": "3",
      "label-cols-lg": "2"
    }
  }, [_c('b-form-input', {
    staticClass: "mr-2",
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearch();
      }
    },
    model: {
      value: _vm.query.dept_name,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "dept_name", $$v);
      },
      expression: "query.dept_name"
    }
  })], 1) : _vm._e()], 1), _c('div', {
    staticClass: "d-flex flex-column flex-xl-row"
  }, [_vm.hiddenSearchField('line_bound') ? _c('b-form-group', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": _vm.displayText('partner.worker_line_bound', '是否綁定Line帳號'),
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-lg": "9"
    }
  }, [_c('b-form-radio-group', {
    model: {
      value: _vm.query.line_bound,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "line_bound", $$v);
      },
      expression: "query.line_bound"
    }
  }, [_c('b-form-radio', {
    staticClass: "mr-2",
    attrs: {
      "value": 0
    }
  }, [_vm._v("全部")]), _c('b-form-radio', {
    staticClass: "mr-2",
    attrs: {
      "value": 1
    }
  }, [_vm._v("綁定")]), _c('b-form-radio', {
    staticClass: "mr-2",
    attrs: {
      "value": -1
    }
  }, [_vm._v("未綁定")])], 1)], 1) : _vm._e(), _vm.hiddenSearchField('is_enabled') ? _c('b-form-group', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": _vm.displayText('partner.is_enabled', '是否啟用'),
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-lg": "9"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mr-2",
    model: {
      value: _vm.query.is_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "is_enabled", $$v);
      },
      expression: "query.is_enabled"
    }
  })], 1) : _vm._e()], 1), _c('div', {
    staticClass: "flex-column"
  }, [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.accordion-2",
      modifiers: {
        "accordion-2": true
      }
    }],
    staticClass: "mb-2 mb-xl-0",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(_vm._s(_vm.displayText("partner.search", "搜尋")))]), _c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.accordion-2",
      modifiers: {
        "accordion-2": true
      }
    }],
    staticClass: "mb-2 mb-xl-0",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.resetSearch
    }
  }, [_vm._v(_vm._s(_vm.displayText("partner.search_reset", "重置搜尋條件")))])], 1)])], 1)]), _c('b-card-text', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.partnerWorkers,
      "fields": _vm.fields,
      "show-empty": ""
    },
    on: {
      "sort-changed": _vm.handleSort
    },
    scopedSlots: _vm._u([{
      key: "head(checkbox)",
      fn: function fn() {
        return [_c('b-form-checkbox', {
          on: {
            "change": _vm.toggleSelectAll
          },
          model: {
            value: _vm.selectAll,
            callback: function callback($$v) {
              _vm.selectAll = $$v;
            },
            expression: "selectAll"
          }
        })];
      },
      proxy: true
    }, {
      key: "cell(checkbox)",
      fn: function fn(data) {
        return [_c('b-form-checkbox', {
          model: {
            value: data.item.selected,
            callback: function callback($$v) {
              _vm.$set(data.item, "selected", $$v);
            },
            expression: "data.item.selected"
          }
        })];
      }
    }, {
      key: "cell(worker_name)",
      fn: function fn(data) {
        return [data.item.highlight ? _c('div', [_c('div', {
          style: {
            'color': data.item.highlightColor
          }
        }, [_c('span', [_vm._v("*")]), _vm._v(" " + _vm._s(data.item.name) + " ")])]) : _c('div', [_vm._v(" " + _vm._s(data.item.name) + " ")])];
      }
    }, {
      key: "cell(staff_name)",
      fn: function fn(data) {
        return [data.item.staff ? _c('div', [_vm._v(" " + _vm._s(data.item.staff.name) + " ")]) : _vm._e()];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_vm.checkPermission([_vm.consts.PARTNER_WORKER_LIST_VIEW]) ? _c('b-button', {
          attrs: {
            "variant": "inverse-primary"
          },
          on: {
            "click": function click($event) {
              return _vm.partnerWorkerViewPush(data.item.id);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-eye mr-1"
        }), _vm._v(" " + _vm._s(_vm.displayText("partner.view", "查看")) + " ")]) : _vm._e(), _vm.checkPermission([_vm.consts.PARTNER_WORKER_MODIFY]) ? _c('b-button', {
          attrs: {
            "variant": "inverse-warning"
          },
          on: {
            "click": function click($event) {
              return _vm.partnerWorkerEditPush(data.item.id);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil mr-1"
        }), _vm._v(" " + _vm._s(_vm.displayText("partner.edit", "編輯")) + " ")]) : _vm._e(), _vm.checkPermission([_vm.consts.PARTNER_WORKER_DELETE]) ? _c('b-button', {
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.deletePartnerWorker(data.item.id);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete mr-1"
        }), _vm._v(" " + _vm._s(_vm.displayText("partner.delete", "刪除")) + " ")]) : _vm._e()];
      }
    }, {
      key: "empty",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center text-muted"
        }, [_c('p', [_vm._v("查無資料")])])];
      },
      proxy: true
    }])
  })], 1)], 1)]), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('div', {
    staticClass: "row justify-content-center align-items-center"
  }, [_c('div', {
    staticClass: "col-12 col-md-auto mb-3"
  }, [_c('span', [_vm._v("目前第 " + _vm._s(_vm.currentPage) + " 頁 / 總共 " + _vm._s(Math.ceil(_vm.totalRows / _vm.query.per_page)) + " 頁")])]), _c('div', {
    staticClass: "col-12 col-md-auto mb-3"
  }, [_vm.totalRows > 0 ? _c('b-pagination', {
    staticClass: "my-auto",
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.query.per_page
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "col-12 col-md-auto mb-3"
  }, [_c('span', [_vm._v("每頁顯示數量：")]), _c('b-form-select', {
    staticClass: "d-inline-block",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "options": _vm.perPageOption
    },
    model: {
      value: _vm.query.per_page,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "per_page", $$v);
      },
      expression: "query.per_page"
    }
  }), _c('span', [_vm._v(" / 總數量: " + _vm._s(_vm.totalRows))])], 1)])])])], 1), _c('PartnerWorkerAddPartner', {
    attrs: {
      "show-add-partner": _vm.showPartnerWorkerChangePartner
    },
    on: {
      "selected": _vm.handlePartnerSelected,
      "close": function close($event) {
        _vm.showPartnerWorkerChangePartner = false;
      }
    }
  }), _c('PartnerWorkerAddStaff', {
    attrs: {
      "show-add-staff": _vm.showPartnerWorkerChangeStaff
    },
    on: {
      "selected": _vm.handleStaffSelected,
      "close": function close($event) {
        _vm.showPartnerWorkerChangeStaff = false;
      }
    }
  }), _c('b-modal', {
    attrs: {
      "id": "modal-upload",
      "title": _vm.displayText('partner.batch_upload_excel_title', '批次上傳')
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              _vm.getSampleExcelFile(_vm.getModuleConfig('partner', 'sample_file.partner_worker_import_xls'), '/excel/partner_worker_list_v2.xlsx');
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file-text"
        }), _vm._v("下載範例檔案")]), _c('b-button', {
          staticClass: "float-right",
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 關閉 ")])];
      }
    }])
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoadingUpload
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "flex-shrink-0 mr-2 mb-0"
  }, [_vm._v("請上傳帳號 Excel 檔案")]), _c('b-form-file', {
    attrs: {
      "plain": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "input": _vm.uploadPartnerWorker
    }
  })], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }